import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
// import Register from './views/Register.vue'

import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'

import store from './store/store'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/auth/login',
      name: 'login',
      component: () => import('./views/Auth/Login.vue'),
      meta: {
        requiresAuth: false,
        title: 'Login',
      },
    },
    {
      path: '/auth/registerOrganization',
      name: 'registerOrganization',
      component: () => import('./views/Auth/RegisterOrganization.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    // {
    //     path: '/register',
    //     name: 'register',
    //     component: Register,
    //     meta: {
    //         requiresAuth: false
    //     }
    // },
    {
      path: '/auth/registerUser',
      name: 'registerUser',
      component: () => import('@/views/Auth/RegisterUser.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/confirmSignUp',
      name: 'confirmation',
      component: () => import('@/views/Auth/ConfirmSignUp'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/organization',
      name: 'organization',
      component: () => import('./views/Organization'),
      params: true,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Organization',
      },
    },
    {
      path: '/invitations',
      redirect: '/auth/registerUser',
    },
    {
      path: '/reject',
      name: 'reject',
      component: () => import('./views/Reject'),
      params: true,
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/prozorro-tenders',
      component: () => import('@/views/Tenders/ProzorroTenders.vue'),
      name: 'prozorrotenders',
      params: true,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Prozorro Tenders',
      },
    },
    {
      path: '/tenders',
      redirect: '/tenders/all'
    },
    {
      path: '/tenders/all',
      component: () => import('@/views/Tenders/AllTenders.vue'),
      name: 'tenders',
      params: true,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Tenders',
      },
    },
    {
      path: '/',
      redirect: '/tenders',
    },
    {
      path: '*',
      redirect: '/tenders',
    },
    {
      path: '/todayTenders',
      component: () => import('@/views/Tenders/TodayTenders.vue'),
      name: 'todayTenders',
      params: true,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/my-bids-tenders',
      name: 'mybidstenders',
      component: () => import('@/views/Tenders/MyBidsTenders.vue'),
      meta: {
        requiresAuth: true,
        title: 'My Bids',
      },
    },
    {
      path: '/my-bids-tenders/:id',
      component: () => import('@/views/Tenders/TenderDetails/MyBidsTenderDetails.vue'),
      name: 'tenderDetail',
      params: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: ':fieldId',
          components: {
            field: () => import('@/views/Tenders/TenderDetails/TenderDetailsFields.vue'),
          },
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/tenders/open',
      name: 'opentenders',
      component: () => import('@/views/Tenders/OpenTenders.vue'),
      meta: {
        requiresAuth: true,
        title: 'Open Tenders',
      },
    },
    {
      path: '/my-draft-bids-tenders',
      name: 'mydraftbidstenders',
      component: () => import('@/views/Tenders/MyDraftBidsTenders.vue'),
      meta: {
        requiresAuth: true,
        title: 'My Draft Bids',
      },
    },
    {
      path: '/my-draft-bids-tenders/:id',
      component: () => import('@/views/Tenders/TenderDetails/MyDraftBidsTenderDetails.vue'),
      name: 'tenderDetail',
      params: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: ':fieldId',
          components: {
            field: () => import('@/views/Tenders/TenderDetails/TenderDetailsFields.vue'),
          },
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/my-tenders/draft',
      component: () => import('@/views/Tenders/DraftTenders.vue'),
      name: 'drafttenders',
      params: true,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Drafts',
      },
    },
    {
      path: '/tenders/:id',
      component: () => import('@/views/Tenders/TenderDetails/PublicTenderDetails.vue'),
      name: 'publicTenderDetail',
      params: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: ':fieldId',
          name: 'publicTenderField',
          components: {
            field: () => import('@/views/Tenders/TenderDetails/TenderDetailsFields.vue'),
          },
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/tenders/starred',
      name: 'starred',
      component: () => import('@/views/Tenders/StarredTenders.vue'),
      meta: {
        requiresAuth: true,
        title: 'Starred',
      },
    },
    {
      path: '/my-tenders',
      redirect: '/my-tenders/all',
    },
    {
      path: '/my-tenders/all',
      name: 'mytenders',
      component: () => import('@/views/Tenders/MyTenders.vue'),
      params: true,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'My Tenders',
      },
    },
    {
      path: '/my-tenders/:id',
      component: () => import('@/views/Tenders/TenderDetails/MyTenderDetails.vue'),
      name: 'tenderDetail',
      params: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: ':fieldId',
          components: {
            field: () => import('@/views/Tenders/TenderDetails/TenderDetailsFields.vue'),
          },
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/prozorro-tenders/:id',
      component: () => import('@/views/Tenders/TenderDetails/ProzorroTenderDetails.vue'),
      name: 'prozorroTenderDetail',
      params: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: ':fieldId',
          name: 'prozorroTenderField',
          components: {
            field: () => import('@/views/Tenders/TenderDetails/TenderDetailsFields.vue'),
          },
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/addMyTender',
      name: 'addmynewtender',
      component: () => import('@/views/AddMyTender.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/editMyTender/:id',
      component: () => import('./views/EditMyTender.vue'),
      name: 'editmytender',
      params: true,
      meta: {
        requiresAuth: true,
      },
    },
    // {
    //     path: '/addNewProcurement',
    //     name: 'addnewprocurement',
    //     component: () => import('@/views/AddNewProcurement.vue'),
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
      path: '/confirm-forgot-password',
      name: 'confirmforgotpassword',
      component: () => import('@/views/Auth/ForgotPasswordConfirm'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile'),
      meta: {
        requiresAuth: true,
        title: 'Profile',
      },
    },
  ],
})

AmplifyEventBus.$on('authState', async (state) => {
  const pushPathes = {
    signedOut: () => {
      localStorage.setItem('authenticated', false)
      localStorage.setItem('currentUser', null)
      localStorage.setItem('currentUserProfile', null)
      store.commit('setAuthState', {
        isAuthenticated: false,
        user: null,
      })
      store.commit('setUser', {
        user: null,
      })
      router.push({ name: 'login' })
    },
    signUp: () => {
      router.push({ name: 'registerUser' })
    },
    confirmSignUp: () => {
      router.push({ name: 'confirmation' })
    },
    signIn: () => {
      router.push({ name: 'login' })
    },
    signedIn: async () => {
      const currentUser = await Auth.currentAuthenticatedUser()
      const credentials = await Auth.currentCredentials()

      store.commit(
        'auth/setAuthState',
        {
          isLoggedIn: true,
          user: currentUser.attributes,
        },
        { root: true },
      )

      localStorage.setItem('authenticated', true)
      localStorage.setItem('identityId', credentials.identityId)
      localStorage.setItem('currentUser', JSON.stringify(currentUser.attributes))

      // if (
      //     !localStorage.getItem('currentUserProfile') ||
      //     localStorage.getItem('currentUserProfile') === 'null'
      // ) {
      //     try {
      //         const currentUserProfile = await Profile.getProfile()
      //         if (currentUserProfile) {
      //             localStorage.setItem(
      //                 'currentUserProfile',
      //                 JSON.stringify(
      //                     currentUserProfile.data.getUserProfile
      //                 )
      //             )
      //             store.commit('setAuthState', {
      //                 user: currentUserProfile.data.getUserProfile,
      //             })
      //         }
      //     } catch (err) {
      //         console.log('err', err)
      //     }
      // }

      router.push({ path: '/' })
    },
  }
  if (typeof pushPathes[state] === 'function') {
    pushPathes[state]()
  }
})

router.beforeEach((to, from, next) => {
  if (
    !['tenderDetail', 'tenders'].includes(from.name) ||
    !['tenderDetail', 'tenders'].includes(to.name)
  ) {
    store.commit('search/setSearchMeta', {
      type: '',
      text: '',
      title: '',
    })
  }
  if (to.meta.title) {
    document.title = to.meta.title + ' - OpenProcurement'
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.auth.isLoggedIn) {
      next({ name: 'login' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
